import React, { Component } from 'react';
import Video, { createLocalVideoTrack } from 'twilio-video';
import { Icon, Tooltip } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { GetVideoToken } from '../../../graphql/queries';
import fetchUrl from '../../../helpers/fetchUrl';
import {
  canScreenShare,
  isChrome,
  isFirefox,
  screenShareId,
} from '../../../components/utility/screenShare';

let screenTrack = null;
export default class VideoComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      identity: null /* Will hold the fake name assigned to the client. The name is generated by faker on the server */,
      roomName: this.props.roomName /* Will store the room name */,
      roomNameErr: false /* Track error for room name TextField. This will    enable us to show an error message when this variable is true */,
      previewTracks: null,
      localMediaAvailable: false /* Represents the availability of a LocalAudioTrack(microphone) and a LocalVideoTrack(camera) */,
      hasJoinedRoom: false,
      activeRoom: null, // Track the current active room
      token: null,
      addFullScreenClass: false,
      isParticipantJoined: false,
    };

    this.getUserScreen = this.getUserScreen.bind(this);
    this.getToken = this.getToken.bind(this);
    this.joinRoom = this.joinRoom.bind(this);
    this.roomJoined = this.roomJoined.bind(this);
    this.toggleVideo = this.toggleVideo.bind(this);
    this.toggleAudio = this.toggleAudio.bind(this);
    this.leaveRoom = this.leaveRoom.bind(this);
    this.testVideo = this.testVideo.bind(this);
    this.fullScreen = this.fullScreen.bind(this);
    this.detachTracks = this.detachTracks.bind(this);
    this.screenCapture = this.screenCapture.bind(this);
    this.stopScreenCapture = this.stopScreenCapture.bind(this);
    this.detachParticipantTracks = this.detachParticipantTracks.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.roomName !== this.props.roomName) {
      this.setState({
        roomName: this.props.roomName,
      });
    }
  }

  componentDidMount() {
    this.getToken();
    this.testVideo();

    window.addEventListener('keydown', e => {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        // e.preventDefault();
        this.setState({
          addFullScreenClass: false,
        });
      }
    });
  }

  getUserScreen() {
    const extensionId = screenShareId;
    if (!canScreenShare()) {
      return;
    }
    if (isChrome()) {
      return new Promise((resolve, reject) => {
        const request = {
          sources: ['screen'],
        };
        window.chrome.runtime.sendMessage(extensionId, request, response => {
          if (response && response?.type === 'success') {
            resolve({ streamId: response?.streamId });
          } else {
            reject('');
          }
        });
      }).then(response => {
        return navigator.mediaDevices.getUserMedia({
          video: {
            mandatory: {
              chromeMediaSource: 'desktop',
              chromeMediaSourceId: response.streamId,
            },
          },
        });
      });
    }
    if (isFirefox()) {
      return navigator.mediaDevices.getUserMedia({
        video: {
          mediaSource: 'screen',
        },
      });
    }
  }

  testVideo() {
    const video = document.getElementById('video');

    // Get access to the camera!
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      // Not adding `{ audio: true }` since we only want video now
      navigator.mediaDevices.getUserMedia({ video: true }).then(function(stream) {
        // video.src = window.URL.createObjectURL(stream);
        video.srcObject = stream;
        video.play();
      });
    }
  }

  async getToken() {
    await fetchUrl
      .BTPORTAL(GetVideoToken)
      .then(({ data: { getVideoToken: { identity, token } } }) =>
        this.setState({ identity, token }),
      )
      .catch(() =>
        window.notify({
          type: 'error',
          message:
            'Unable to connect to video call. Please reach out to your therapist about the issue',
          icon: 'info-sign',
        }),
      );
    // await this.setState({ identity, token }, () => {
    //   this.joinRoom();
    // });
    // this.joinRoom();
  }

  joinRoom() {
    this.setState(
      {
        startCall: true,
      },
      () => this.props.changeState(true),
    );
    if (this.state.token) {
      const connectOptions = {
        name: this.state.roomName,
      };

      if (this.state.previewTracks) {
        connectOptions.tracks = this.state.previewTracks;
      }
      Video.connect(this.state.token, connectOptions).then(this.roomJoined, error => {
        alert('Could not connect to Twilio: ' + error.message);
      });
    } else {
      this.getToken();
    }
  }

  detachTracks(tracks) {
    tracks.forEach(track => {
      track.detach().forEach(detachedElement => {
        detachedElement.remove();
      });
    });
  }

  detachParticipantTracks(participant) {
    const tracks = Array.from(participant.tracks.values());
    this.detachTracks(tracks);
  }

  attachTracks(tracks, container, shouldRemoveFirst = false) {
    if (shouldRemoveFirst) {
      while (container?.firstChild) {
        container.removeChild(container.lastChild);
      }
    }
    tracks.forEach(track => {
      container && container.appendChild(track.attach());
    });
  }

  // Attach the Participant's Tracks to the DOM.
  attachParticipantTracks(participant, container, shouldRemoveFirst = false) {
    const tracks = Array.from(participant.tracks.values());
    this.attachTracks(tracks, container, shouldRemoveFirst);
  }

  roomJoined(room) {
    // Called when a participant joins a room

    this.setState({
      activeRoom: room,
      localMediaAvailable: true,
      hasJoinedRoom: true, // Removes ‘Join Room’ button and shows ‘Leave Room’
    });

    // Attach LocalParticipant's tracks to the DOM, if not already attached.
    const previewContainer = this.refs.localMedia;
    if (!(previewContainer && previewContainer.querySelector('video'))) {
      this.attachParticipantTracks(room.localParticipant, previewContainer);
    }

    // Attach the Tracks of the room's participants.
    room.participants.forEach(participant => {
      const previewContainer = this.refs.remoteMedia;
      this.attachParticipantTracks(participant, previewContainer);
    });

    // Participant joining room
    room.on('participantConnected', participant => {
      this.setState({
        isParticipantJoined: true,
      });
    });

    // Attach participant’s tracks to DOM when they add a track
    room.on('trackAdded', (track, participant) => {
      const previewContainer = this.refs.remoteMedia;
      this.attachTracks([track], previewContainer);
    });

    // Detach participant’s track from DOM when they remove a track.
    room.on('trackRemoved', (track, participant) => {
      this.detachTracks([track]);
    });

    // Detach all participant’s track when they leave a room.
    room.on('participantDisconnected', participant => {
      this.detachParticipantTracks(participant);
    });

    // Once the local participant leaves the room, detach the Tracks
    // of all other participants, including that of the LocalParticipant.
    room.on('disconnected', () => {
      if (this.state.previewTracks) {
        this.state.previewTracks.forEach(track => {
          track.stop();
        });
      }
      this.detachParticipantTracks(room.localParticipant);
      room.participants.forEach(this.detachParticipantTracks);
      this.state.activeRoom = null;
      this.setState({
        hasJoinedRoom: false,
        localMediaAvailable: false,
        addFullScreenClass: false,
        isParticipantJoined: false,
      });
    });
  }

  leaveRoom() {
    this.stopScreenCapture();
    this.state.activeRoom.disconnect();
    this.setState(
      {
        hasJoinedRoom: false,
        localMediaAvailable: false,
        addFullScreenClass: false,
        isParticipantJoined: false,
        startCall: false,
      },
      () => {
        this.testVideo();
        this.props.changeState();
      },
    );
  }

  toggleAudio() {
    const { isAudioActive } = this.state;
    this.setState(
      {
        isAudioActive: !isAudioActive,
      },
      () => {
        if (this.state.isAudioActive) {
          const { localParticipant } = this.state.activeRoom;
          localParticipant.audioTracks.forEach(function(audioTrack) {
            audioTrack.disable();
          });
        } else {
          const { localParticipant } = this.state.activeRoom;
          localParticipant.audioTracks.forEach(function(audioTrack) {
            audioTrack.enable();
          });
        }
      },
    );
  }

  handleVideoTrack = (screenTrack, isReset = false) => {
    const { localParticipant } = this.state.activeRoom;
    const videoTrack = localParticipant.videoTracks.values().next().value;
    localParticipant.removeTrack(videoTrack);
    const previewContainer = this.refs.localMedia;
    if (isReset) {
      createLocalVideoTrack().then(track => {
        localParticipant.addTrack(track);
        while (previewContainer?.firstChild) {
          previewContainer.removeChild(previewContainer.lastChild);
        }
        previewContainer && previewContainer.appendChild(track.attach());
        this.setState({
          hideScreenShare: false,
        });
      });
    } else {
      localParticipant.addTrack(screenTrack);
      this.attachParticipantTracks(localParticipant, previewContainer, true);
    }
  };

  screenCapture() {
    if (this.state.hideScreenShare) {
      this.stopScreenCapture();
      return;
    }
    this.getUserScreen().then(stream => {
      screenTrack = stream.getVideoTracks()[0];
      screenTrack.onended = () => {
        // Click on browser UI stop sharing button
        this.stopScreenCapture();
      };
      screenTrack.inactive = () => {
        // Click on browser UI stop sharing button
        this.stopScreenCapture();
      };
      this.handleVideoTrack(screenTrack);
      this.setState({
        hideScreenShare: true,
      });
    });
  }

  stopScreenCapture() {
    this.handleVideoTrack(null, true);
    screenTrack = null;
  }

  fullScreen() {
    this.setState({
      addFullScreenClass: !this.state.addFullScreenClass,
    });
  }

  toggleVideo() {
    const { isVideoActive } = this.state;
    this.setState(
      {
        isVideoActive: !isVideoActive,
      },
      () => {
        if (this.state.isVideoActive) {
          const { localParticipant } = this.state.activeRoom;
          localParticipant.videoTracks.forEach(function(videoTrack) {
            videoTrack.disable();
          });
        } else {
          const { localParticipant } = this.state.activeRoom;
          localParticipant.videoTracks.forEach(function(videoTrack) {
            videoTrack.enable();
          });
        }
      },
    );
  }

  render() {
    const { hasJoinedRoom, addFullScreenClass } = this.state;
    return (
      <div className={`bt_portal-video_chat ${addFullScreenClass ? '-full-screen' : ''}`}>
        <div className={`local_video-welcome_card ${hasJoinedRoom ? '-joined' : ''}`}>
          <div className='welcome_note'>
            <div className='local_video_container'>
              {!hasJoinedRoom ? <video id='video' ref='localMedia' /> : ''}
            </div>
          </div>
          {hasJoinedRoom ? (
            <div
              hidden={this.state.isVideoActive}
              className='local_video'
              style={{ height: hasJoinedRoom ? 'auto' : 500 }}
            >
              <div ref='localMedia' />{' '}
            </div>
          ) : (
            ''
          )}
        </div>
        {hasJoinedRoom && <div className='flex-item' ref='remoteMedia' id='remote-media' />}
        {!hasJoinedRoom ? (
          <div>
            <div className='video_chat-action' style={{ left: '50%' }}>
              <Tooltip title='Start Video Call'>
                <div onClick={this.joinRoom} className='video-action-container open'>
                  <Icon size={100} type='phone' />
                </div>
              </Tooltip>
              <CopyToClipboard
                text={`${window.location.origin}/public/video/${this.state.roomName}/${this.props.therapistId}`}
                onCopy={() =>
                  window.notify({
                    type: 'success',
                    message: 'Successfully Copied!',
                    icon: 'check-circle',
                  })
                }
              >
                <Tooltip title='Copy sharable link'>
                  <div className='video-action-container -copy-link'>
                    <Icon size={100} type='copy' />
                  </div>
                </Tooltip>
              </CopyToClipboard>
            </div>
          </div>
        ) : null}
        {hasJoinedRoom && (
          <div className='video_chat-action'>
            <Tooltip title='Mute Audio'>
              <div
                onClick={this.toggleAudio}
                className={`video-action-container audio ${
                  this.state.isAudioActive ? '-disabled' : ''
                }`}
              >
                <div className='crossbar' />
                <Icon size={100} type='audio' />
              </div>
            </Tooltip>
            <Tooltip title='Hide Video'>
              <div
                onClick={this.toggleVideo}
                className={`video-action-container camera ${
                  this.state.isVideoActive ? '-disabled' : ''
                }`}
              >
                <div className='crossbar' />
                <Icon size={100} type='video-camera' />
              </div>
            </Tooltip>
            <Tooltip title='Share Screen'>
              <div
                onClick={this.screenCapture}
                className={`video-action-container camera ${
                  this.state.hideScreenShare ? '-disabled' : ''
                }`}
              >
                <div className='crossbar' />
                <Icon size={100} type='select' />
              </div>
            </Tooltip>
            <Tooltip title='Disconnect'>
              <div onClick={this.leaveRoom} className='video-action-container close'>
                <Icon size={100} type='logout' />
              </div>
            </Tooltip>
            {this.state.isParticipantJoined ? (
              <div onClick={this.fullScreen} className='video-action-container -fullscreen'>
                <Icon size={100} type={addFullScreenClass ? 'fullscreen-exit' : 'fullscreen'} />
              </div>
            ) : null}
            <CopyToClipboard
              text={`${window.location.origin}/public/video/${this.state.roomName}/${this.props.therapistId}`}
              onCopy={() =>
                window.notify({
                  type: 'success',
                  message: 'Successfully Copied!',
                  icon: 'check-circle',
                })
              }
            >
              <Tooltip title='Copy sharable link'>
                <div className='video-action-container -copy-link'>
                  <Icon size={100} type='copy' />
                </div>
              </Tooltip>
            </CopyToClipboard>
          </div>
        )}
      </div>
    );
  }
}
